/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Directive, ElementRef, HostListener } from '@angular/core'
import { NgControl } from '@angular/forms'

@Directive({
  selector: '[appTrim]',
})
export class TrimDirective {
  constructor(public ngControl: NgControl, public el: ElementRef) {}

  @HostListener('ionBlur', ['$event'])
  onBlur(event) {
    this.onInputChange(event)
  }

  @HostListener('keydown.enter', ['$event'])
  keydownEnter(event) {
    this.onInputChange(event)
  }

  onInputChange(event) {
    if (event.srcElement.value == null) {
      return
    }

    let newVal = event.srcElement.value.trim()

    if (newVal.length === 0) {
      newVal = ''
    }

    if (newVal === '') {
      this.ngControl.control.setValue(null)
    } else {
      this.ngControl.control.setValue(newVal)
      this.ngControl.valueAccessor.writeValue(newVal)
    }
  }
}
